/**
 * 会话守卫：未登录跳 /login；ready 前不渲染（防闪烁）。
 * 无权限页（403 场景）一期单角色 ADMIN，预留 ForbiddenPage 组件。
 */
import { Navigate, Outlet, useLocation } from 'react-router';
import { useSession } from '../lib/session';
import { EmptyState, Button } from '@chronospeak/ui';

export function RequireAuth() {
  const { admin, ready } = useSession();
  const location = useLocation();
  if (!ready) {
    return (
      <main style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}>
        <p style={{ color: 'var(--muted)' }}>会话恢复中…</p>
      </main>
    );
  }
  if (!admin) {
    return <Navigate to='/login' replace state={{ from: location.pathname }} />;
  }
  if (admin.mustChangePassword) {
    return <Navigate to='/change-password' replace />;
  }
  return <Outlet />;
}

/** 无权限页（403）：返回工作台入口 */
export function ForbiddenPage() {
  return (
    <main className='admin-page'>
      <EmptyState title='没有访问权限' description='当前账号无权访问该页面。如需权限请联系站点负责人。'>
        <Button onClick={() => history.back()}>返回</Button>
      </EmptyState>
    </main>
  );
}
